import { Routes } from '@angular/router'
import { MAIN_ROUTES } from './main/main.routes'
import { authGuard } from '@core/auth.guard'

export const routes: Routes = [
    {
        path: 'open',
        children: [
            {
                path: '**',
                loadComponent: () =>
                    import('./redirect-store/redirect-store.component').then(
                        (c) => c.RedirectStoreComponent
                    ),
            },
        ],
    },
    {
        path: '',
        title: 'Qazakhgaz Loyalty System',
        canActivate: [authGuard],
        canActivateChild: [authGuard],
        loadComponent: () =>
            import('./main/main.component').then(
                (component) => component.Maincomponent
            ),
        children: MAIN_ROUTES,
    },
    {
        path: 'auth',
        title: 'Авторизация',
        loadComponent: () =>
            import('./auth/auth.component').then(
                (component) => component.AuthComponent
            ),
    },
]
